export function homeIntroSlider() {

	let carousel = $('.js-home-intro-image-slider');

	carousel.owlCarousel({
		items: 1,
		dots: true,
		nav: false,
		margin: 20,
		animateIn: 'fadeIn',
		animateOut: 'fadeOut',
		autoplay: true,
		loop: true,
		autoplayTimeout: 5000
	})

	return 'homeIntroSlider';
}